<!-- eslint-disable prettier/prettier -->
<template>
    <div>
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <h3 class="text-center">Edit Content <span class="smh"></span></h3>
          </b-col>
          
        </b-row>
        <b-row>
          <b-col class="m-1 p-3">
              <form @submit.prevent="editnotification">
                  
                  <b-form-group label="Content Title" class="label" label-for="target">
                      <b-form-input type="text" id="title" v-model="create.title"></b-form-input>
                  </b-form-group>
  
  
                  <b-form-group label="Content Body" label-for="title" class="label">
                      <vue2-tinymce-editor v-model="create.body"></vue2-tinymce-editor>
                  </b-form-group>
  
                <b-form-group
                  label="Notification Action"
                  class="label"
                  label-for="target"
                >
                  <b-form-group>
                    <b-form-select v-model="create.action">
                      <b-form-select-option value="take_test"
                        >Take test</b-form-select-option
                      >
                      <b-form-select-option value="schedule_test"
                        >Schedule</b-form-select-option
                      >
                      <b-form-select-option value="open_analytics"
                        >See Analytics</b-form-select-option
                      >
                      <b-form-select-option value="upgrade"
                        >Proceed to Upgrade</b-form-select-option
                      >
                      <b-form-select-option value="no_action"
                        >No action</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </b-form-group>
    
                <b-form-group
                  label="Notification Status"
                  class="label"
                  label-for="target"
                >
                  <b-form-group>
                    <b-form-select v-model="create.status">
                      <b-form-select-option value="show_in_app"
                        >Show in App</b-form-select-option
                      >
                      <b-form-select-option value="hide_in_app"
                        >Hide in App</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </b-form-group>
   
  
                  <b-overlay :show="uploadingcimage">
                      <template #overlay>
                          <div class="text-center">
                              <b-icon-file-image font-scale="3" animation="throb"></b-icon-file-image>
                              <p>Uploading Image...</p>
                          </div>
                      </template>
                      <b-form-group>
                          <b-form-file v-model="filedir" ref="file" placeholder="Choose a file or drop it here" drop-placeholder="Drop File here..." @input="handleImage"></b-form-file>
                      </b-form-group>
                      <img :src="filelink" v-if="filelink?.length > 0" class="image-attachment dispimage" />
                  </b-overlay>
  
                  <div v-if="sent" class="alert alert-success p-3">
                      Notification updated Successfully
                  </div>
  
                  <div class="text-center">
                      <b-overlay
                          :show="sending"
                          rounded
                          opacity="0.6"
                          spinner-small
                          spinner-variant="primary"
                          class=""
                      >
                          <div class="mt-4">
                              <b-button :disabled="chkfields" type="submit" variant="outline-success" class="m-lg-3 mt-2 p-2 action-button"> Update Content </b-button>
                          </div>                  
                      </b-overlay>
  
                      <b-button v-if="sending" @click="sending = false" class="w-50 p-2 mt-3" variant="dark">
                        Cancel
                      </b-button>
  
                  </div>
              </form>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>

<script>
import { mapActions, mapState } from "vuex";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import axios from "axios";
import store from "@/store";

export default {
  components: {
    Vue2TinymceEditor
  },

  data() {
    return {
      create: this.getForm(),
      sending: false,
      sent: false,
      levels: [0, 1, 2, 3, 4, 5],
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      addresponse: "",
      opencreate: false,
      // editor : ClassicEditor,
      // config : config,
      isCheckingcode: false,
      notificationexists: false,
      uploadingfile: false,
      uploadedfile: false,
      uploadmessage: "",
      mtype: "",
      filedir: "",
      filelink: "",
      uploadingcimage: false,
      status: ""
      // datacount : this.partnershipsarray[0].count
    };
  },
  created() {
    this.populateContent();
  },
  mounted() {
    this.populateContent();
  },
  watch: {
    notifications() {
      if (this.notifications.length > 0) {
        this.populateContent();
      }
    }
  },
  computed: {
    ...mapState({
      users: state => state.admin.allusers,
      details: state => state.loginmaster.details,
      notifications: state => state.admin.notifications,
      adminadded: state => state.admin.adminadded,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.api_origin
    }),
    chkfields() {
      if (
        this.sending ||
        this.create.title.length <= 0 ||
        this.create.action.length <= 0 ||
        this.create.status.length <= 0 ||
        this.create.body.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("admin/fetchNotifications");
    next();
  },
  methods: {
    ...mapActions("admin", ["updateNotification", "fetchNotifications"]),
    getForm() {
      return {
        discount: 1,
        title: "",
        target: "",
        description: "",
        notificationcode: "",
        status: "Active",
        type: "Full"
      };
    },
    editnotification() {
      this.sending = true;
      // this.user.organization = this.details.clearance_organization

      return this.updateNotification(this.create).then(() => {
        this.sending = false;
        this.sent = true;

        // this.create.title = ""
        // this.create.description = ""
        // this.create.target = ""
        // this.create.notificationcode = ""

        this.fetchNotifications();
      });
    },
    handleImage() {
      this.uploadingcimage = true;
      let ifile = this.$refs.file.files[0];
      this.imageUpload(ifile).then(() => {
        this.create.image = this.url;
        if (this.status == "success") {
          this.uploadingcimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.filelink = this.url;
          this.setFile(this.url);
          this.attachmentfiles = this.url;
          this.create.image = this.url;
          this.filedir = "";
        }
      });
    },
    imageUpload(imagefile) {
      this.url = "";
      this.status = "";
      let formData = new FormData();
      formData.append("image", imagefile);
      formData.append("environment", this.environ);
      formData.append("origin", this.origin);
      formData.append("pretag", "notificationimage");
      let apilink =
        this.environ == "development"
          ? `${this.origin}/ImageHandler.php`
          : `${this.origin}/ImageHandler.php`;

      return axios
        .post(apilink, formData, {
          header: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(response => {
          this.uploadingcimage = false;
          this.url = response.data.url;
          // this.create.image = this.response.data.url;
          this.status = "success";
        })
        .catch(() => {
          this.status = "error";
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          //console.log(error);
        });
    },
    populateContent() {
      let id = this.$route.params.trackid;
      let currentnotification = this.notifications.filter(x => x.id == id)[0];
      this.filelink = currentnotification.image;

      this.create = {
        title: currentnotification.title,
        action: currentnotification.action,
        status: currentnotification.status,
        body: currentnotification.body,
        image: currentnotification.image,
        id: currentnotification.id
      };
    },
    stopproceed() {
      this.sending = false;
    }
  }
};
</script>

<style scoped>
.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
}
.head-p {
  width: 12%;
  padding: 2px;
}
.flex-input-parent {
  display: flex;
}
.left-flex-child {
  width: 95%;
}
.right-flex-child {
  width: 5%;
}
.hidden {
  display: none;
}
.full-width-child {
  width: 100%;
}
.font-green {
  color: green;
}
.errtxt {
  color: red;
}
.dispimage {
  width: 70%;
  height: 400px;
  border: 3px solid white;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
  .dispimage {
    width: 100%;
  }
}
</style>
